import type { IconData } from '@stacksjs/iconify-core'

export const arrowRoadmapSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.46 10.5H4a2.5 2.5 0 0 1 0-5h4.46a7.003 7.003 0 0 1 13.08 0H35c5.799 0 10.5 4.701 10.5 10.5c0 5.26-3.868 9.617-8.915 10.381a7.003 7.003 0 0 1-13.125.119H13a5.5 5.5 0 0 0-1.462 10.804a7.002 7.002 0 0 1 13.002.196H35.6c.105-.755.258-1.492.46-2.193a2.5 2.5 0 0 1 3.686-1.453l.015.01l.037.022l.052.032l.082.05a59 59 0 0 1 2.045 1.311c1.175.789 2.738 1.904 3.789 2.95a2.5 2.5 0 0 1 0 3.542c-1.051 1.046-2.614 2.161-3.789 2.95a59 59 0 0 1-2.179 1.393l-.037.022l-.015.01a2.502 2.502 0 0 1-3.685-1.453A15.6 15.6 0 0 1 35.6 42.5H24.54a7.003 7.003 0 0 1-13.125-.119C6.368 41.617 2.5 37.261 2.5 32c0-5.799 4.701-10.5 10.5-10.5h10.46a7.003 7.003 0 0 1 13.002-.196A5.5 5.5 0 0 0 35 10.5H21.54a7.003 7.003 0 0 1-13.08 0\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRoadmapSolid
